<template>
    <div class="mb-6">
        <div class="related-link text-center">
            <router-link class=""
                         :to="{ name: 'course.details', params: { slug: course.slug }}">
                <img
                        style="max-height: 160px; max-width: 100%"
                        v-if="course.caticon"
                        :src="course.caticon"
                >

                <img
                        style="max-height: 160px; max-width: 100%"
                        src="@/assets/hometeacher/images/home-kurs-none.png"
                        v-else
                >
            </router-link>
        </div>
        <div class="related-title text-center mt-4" @click="toDetails">
            <span class="related-course-name">{{ course.course }}</span>,
            <span class="related-course-age"> {{ageText(course) }}</span>
        </div>
    </div>
</template>

<script>

    import courseApi from "../../data/CourseApi";

    export default {
        name: 'CourseRelatedItem',

        props: {
            course: {
                type: Object,
                required: true,
            }
        },

        methods: {
            toDetails() {
                this.$router.push('/course/' + this.course.slug + '/details')
            },

            ageText() {
                if (this.course.ages && this.course.ages.length > 0) {
                    let ages = []
                    for (let age of this.course.ages) {
                        ages.push(courseApi.getAgeName(age.idage))
                    }
                    return ages.join(", ")
                }
                return "";
            },
        },

        data() {
            return {}
        },

        mounted() {
        },

    }
</script>
<style scoped>

    .related-course-age {
        /*white-space: nowrap;*/
        font-family: "Manrope Bold";
        font-size: 18px;
        color: #5ab947;
    }

    .related-course-name {
        color: #231c37;
        font-family: "Manrope Bold";
        font-size: 24px;
        line-height: 24px;
        border-bottom: 1px solid #d7e1e5;
    }

    .related-title {
        font-family: "Manrope Bold";
        font-size: 24px;
        line-height: 28px;
        cursor: pointer;
    }

    .related-link img {
        border-radius: 10px;
    }


    @media (min-width: 992px) {

    }


    @media (max-width: 991.8px) {

    }
</style>
